
import api from './api';
import { AuthResponse } from '../types';

export const authService = {
  login: async (payload: any): Promise<AuthResponse> => {
    const response = await api.post('/auth/login', payload);
    if (response.data.status === false) {
      throw new Error(response.data.message);
    }
    return response.data;
  },
  
  register: async (payload: any): Promise<any> => {
    const response = await api.post('/auth/register', payload);
    if (response.data.status === false) {
      throw new Error(response.data.message);
    }
    return response.data;
  },
  
  forgotPassword: async (payload: { email: string }): Promise<any> => {
    const response = await api.post('/auth/forgot-password', payload);
    if (response.data.status === false) {
      throw new Error(response.data.message);
    }
    return response.data;
  },
  
  resetPassword: async (payload: any): Promise<any> => {
    const response = await api.post('/auth/reset-password', payload);
    if (response.data.status === false) {
      throw new Error(response.data.message);
    }
    return response.data;
  },

  getProfile: async (): Promise<any> => {
    const response = await api.get('/user/profile');
    return response.data;
  },

  logout: () => {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('auth_role');
  }
};
